import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';

import { LeadEmailFormContactInputFieldNameEnum } from 'common/module/lead/email/form/contact/input-field-name.enum';
import { LeadEmailFormContactServiceInterface } from 'common/service/lead-email-form-contact/service.interface';

export class LeadEmailFormContactStore implements LeadEmailFormContactServiceInterface {
  /**
   * Cached Email lead data
   */
  private emailLeadData: DataKeyValueStringInterface;

  /**
   * @inheritDoc
   */
  public initialize(): void {
    this.emailLeadData = {};
  }

  /**
   * @inheritDoc
   */
  public setData(inputFieldName: LeadEmailFormContactInputFieldNameEnum, value: string): void {
    this.emailLeadData[inputFieldName] = value;
  }

  /**
   * @inheritDoc
   */
  public getData(inputFieldName: LeadEmailFormContactInputFieldNameEnum): string {
    if (!this.emailLeadData || Object.keys(this.emailLeadData).indexOf(inputFieldName) === -1) {
      return;
    }
    return this.emailLeadData[inputFieldName];
  }
}
